<template>
  <div id="varietytabs" class="tabs max-w-full">
    <Loading v-if="!tabs" />

    <h2
      v-if="Array.isArray(tabs) && tabs.length < 1"
      class="text-xl p-5 text-center"
    >No varieties found!</h2>

    <!-- Vuetify Tab Bar -->
    <v-tabs
      v-if="Array.isArray(tabs) && tabs.length > 0"
      v-model="tab"
      show-arrows
      next-icon="mdi-arrow-right-bold-box-outline"
      prev-icon="mdi-arrow-left-bold-box-outline"
      optional
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="(item, index) in tabs"
        :key="index"
        :class="['flex flex-col items-center']"
        @change="getVarietyProducts(item.id)"
        :value="index.id"
      >
        <div v-if="item.image" :class="['mb-2 md:mb-3 img rounded-full overflow-hidden border-2 border-solid border-grey-500']">
          <picture class="block w-16">
            <img :src="`${item.image.src}`" :alt="item.title" />
          </picture>
        </div>
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-if="tabs"
      v-model="tab"
      touchless
      class="py-5 sm:px-10"
    >
      <v-tab-item
        v-for="(item, index) in tabs"
        :key="index"
        class="grid grid-flow-row grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 mx-2"
      >
        <Loading v-if="!Array.isArray(getActiveTabContent)" class="col-span-12" />

        <v-alert
          v-if="Array.isArray(getActiveTabContent) && getActiveTabContent.length < 1"
          type="info"
          outlined
          text
          class="col-span-12 m-4"
        >
          <h1 class="text-sm ml-5">{{`${item.name} collection is being updated, check back soon!`}}</h1>
        </v-alert>

        <v-card
          v-for="(itemProduct, indexProduct) in getActiveTabContent"
          :key="indexProduct"
          @click="$router.push(`/product/${$route.params.brand}/${item.name.toLowerCase()}/${itemProduct.sku}/`)"
          outlined
          flat
        >
          <template v-if="itemProduct.images.length > 0">
            <v-img :src="itemProduct.images[0].src">
            </v-img>
          </template>

          <v-card-text>
            <h6 class="text-xs">SKU</h6>
            <span class="text-xs bg-gray-600 p-2 text-white rounded-sm">
              {{ itemProduct.sku }}
            </span>
          </v-card-text>

          <v-card-title>
            {{ itemProduct.name }}
          </v-card-title>
        </v-card>

        <!-- <div class="tab-content-img">
          <VueSlickCarousel v-bind="slider.settings.tabContent" :class="[ 'py-5 flex flex-row flex-wrap' ]">
            <div v-for="(contentItem, index) in item.content" :key="index" :class="[ '', ]">
              <a :href="contentItem.url" :class="['block']">
                <div class="img mb-5 flex flex-col items-center" v-if="typeof contentItem.img == 'object' && contentItem.img.main != 'undefined'">
                  <picture>
                    <img :src="require(`@/img/${contentItem.img.main}`)" :alt="contentItem.title" width="300" height="300" />
                  </picture>
                </div>
                <p class="title text-center text-xs">{{ contentItem.title }}</p>
              </a>
            </div>
          </VueSlickCarousel>
        </div> -->
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
// Material Tabs
// import { MDCTabBar } from '@material/tab-bar';

// Tabs-Slider
// import TabsSlider from 'tabs-slider';
// import 'tabs-slider/dist/css/tabs.css';

// Slick
// import VueSlickCarousel from 'vue-slick-carousel';
// import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Loading from "@/components/Loading.vue";

export default {
  name: 'VarietyTabs',

  // props: {
  //   tabs: Array,
  // },

  components: {
    // VueSlickCarousel,
    Loading,
  },

  mounted: function () {
    console.log(this.selectedTabIndex);
  },

  computed: {
    ...mapState(['axiosWc']),
    ...mapState({
      fullConfig: state => state.fullConfig,
      tabs: state => state.pages.brand.tabs,
      tabsCliff: state => state.pages.cliff.varietyTabs,
      tabsForce: state => state.pages.force.varietyTabs,
      tabsClassicMilano: state => state.pages['classic-milano'].varietyTabs,
    }),
    ...mapGetters(['getUrlApi','getActiveTabContent']),
  },

  data: function () {
    return {
      tab: null, // Required for Vuetify tabs
      initVarietyTabs: '',
      selectedTabIndex: 1,
      // Slider options
      slider: {
        isActive: false,
        settings: {
          varietyTabs: {},
          varietyTabsContent: {},
          tabContent: {
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            draggable: false,
            responsive: [
              {
                breakpoint: parseInt(this.$store.state.fullConfig.theme.screens.xl) - 1,
                settings: {
                  slidesToShow: 3,
                },
              },
              {
                breakpoint: parseInt(this.$store.state.fullConfig.theme.screens.lg) - 1,
                settings: {
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: parseInt(this.$store.state.fullConfig.theme.screens.sm) - 1,
                settings: {
                  slidesToShow: 1,
                },
              }
            ],
          },
        },
      },
    }
  },
  methods: {
    ...mapActions([/* 'screenSize', */'setVarietyTab']),
    ...mapMutations({
      SET_VARIETY_PRODUCTS: "SET_VARIETY_PRODUCTS",
      SET_CURRENT_TAB_PRODUCTS: "SET_CURRENT_TAB_PRODUCTS",
    }),
    getVarietyProducts: async function (varietyId) {
      this.SET_CURRENT_TAB_PRODUCTS(false);
      const products = await this.axiosWc.get(`${this.getUrlApi}/wc/v3/products/?category=${varietyId}`);
      this.SET_CURRENT_TAB_PRODUCTS(products.data);
    },
    showTabContent: function (evt) {
      console.log(evt);
    },
  }
}
</script>

<style lang="scss">
</style>